import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: 12,
    slidesPerView: 3,
});
var swiper2 = new Swiper(".section1 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".section1 .next",
        prevEl: ".section1 .prev",
    },
});

$('.zoom-box').each(function () {

    var $box = $(this);
    var $img = $box.children('img');
    var $lens = $box.find('.zoom-lens');

    var zoom = 2;

    $box.on('mouseenter', function () {

        var imgSrc = $img.attr('src');

        var boxWidth = $box.innerWidth();
        var boxHeight = $box.innerHeight();

        /*
         * 放大图片
         */
        $lens.css({
            display: 'block',
            backgroundImage: 'url("' + imgSrc + '")',
            backgroundSize: (boxWidth * zoom) + 'px ' + (boxHeight * zoom) + 'px'
        });

    });

    $box.on('mousemove', function (e) {

        var offset = $box.offset();

        var boxWidth = $box.innerWidth();
        var boxHeight = $box.innerHeight();

        /*
         * 鼠标相对于图片的位置
         */
        var x = e.pageX - offset.left;
        var y = e.pageY - offset.top;

        /*
         * 放大框尺寸
         */
        var lensWidth = $lens.outerWidth();
        var lensHeight = $lens.outerHeight();

        /*
         * 让放大框中心跟随鼠标
         */
        var left = x - lensWidth / 2;
        var top = y - lensHeight / 2;

        /*
         * 防止放大框跑出图片
         */
        left = Math.max(
            0,
            Math.min(left, boxWidth - lensWidth)
        );

        top = Math.max(
            0,
            Math.min(top, boxHeight - lensHeight)
        );

        $lens.css({
            left: left,
            top: top
        });

        /*
         * 鼠标所在位置百分比
         */
        var percentX = x / boxWidth;
        var percentY = y / boxHeight;

        /*
         * 放大图尺寸
         */
        var bgWidth = boxWidth * zoom;
        var bgHeight = boxHeight * zoom;

        /*
         * 计算背景图位置
         *
         * 让鼠标所在的原图位置
         * 始终出现在放大框中心
         */
        var bgX =
            -(percentX * bgWidth - lensWidth / 2);

        var bgY =
            -(percentY * bgHeight - lensHeight / 2);

        $lens.css({
            backgroundPosition: bgX + 'px ' + bgY + 'px'
        });

    });

    $box.on('mouseleave', function () {

        $lens.hide();

    });

});

$(".product-pop input").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop input").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(".product-pop textarea").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop textarea").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(".product-btn").click(function() {
    $(".product-pop").css('display','flex');
    let value = $(this).parent().parent().find(".product-title").text();
    $(".product-pop .form form ul li:nth-child(2) input").val(value);
})
$(".product-pop .model").click(function() {
    $(".product-pop").hide();
})
$(".product-pop .out").click(function() {
    $(".product-pop").hide();
})